import React from 'react';
import classNames from 'classnames';
import { Tooltip } from 'devextreme-react/tooltip';
import styles from './SummaryFilter.module.scss';
import moment from 'moment';
import PropTypes from 'prop-types';
import withRouter from '../../util/customWithRouter';
import { TextLink } from '@otcmarketsgroup/otcm-ui';
import { Button } from '../../components/Button';
import { TextBox, DateBox, SelectBox } from 'devextreme-react';
import { filterDatePattern } from '../../util/tradeFilterConstants';
import { datePattern } from '../../util/constants';

const summaryTypes =
[

  { id: 'sku', value: 'SKU' },
  { id: 'venue', value: 'Venue' },
  { id: 'venueRange', value: 'Venue Summary' },
  { id: 'symbol', value: 'Symbol' },
  { id: 'firm', value: 'Firm' },
  { id: 'daily', value: 'Daily' }

];
function getMonday () {
  let d = new Date();
  var day = d.getDay();

  var diff = d.getDate() - day + (day === 0 ? -6 : 1);
  d.setDate(diff);
  return d;
}
const initialState = {
  date: new Date(),
  endDate: new Date(),
  startDate: getMonday(),
  summaryType: summaryTypes[0].id,
  errorMessages: [],
  mpid: ''
};

class SummaryFilter extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      ...initialState
    };

    // preserve the initial state in a new object
    this.baseState = this.state;
    this.getSummaryDataFilter = this.getSummaryDataFilter.bind(this);
    this.clearData = this.clearData.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.toggleMpidInfoTooltip = this.toggleMpidInfoTooltip.bind(this);
  }

  componentDidMount () {
    const params = new URLSearchParams(this.props.router.location.search);
    const mpid = params.get('mpid');
    if (mpid) {
      this.setState({
        mpid: mpid || '',
        date: new Date()
      },
      this.handleSubmit
      );
    } else {
      this.setState({
        date: new Date()
      },
      this.handleSubmit
      );
    }
  }

  handleChange (event, name) {
    //  console.log(event.value);
    //  console.log(name);
    this.setState({
      [name]: event.value
    });
  }

  handleSubmit () {
    let queryParam = this.state;
    //  console.log(queryParam);
    var errorMessages = [];

    if (queryParam.summaryType === 'daily' || queryParam.summaryType === 'venueRange') {
      if (!('startDate' in queryParam) || queryParam['startDate'] === null) {
        errorMessages.push('Please select start date');
      }
      if (!('endDate' in queryParam) || queryParam['endDate'] === null) {
        errorMessages.push('Please select end date');
      }
      if (queryParam['endDate'] !== null && queryParam['startDate'] !== null) {
        if (queryParam['startDate'] > queryParam['endDate']) {
          errorMessages.push('Start date can not be greater than end date');
        }
      }
    } else {
      if (!('date' in queryParam) || queryParam['date'] === null) {
        errorMessages.push('Please select Trade date');
      }
      if (queryParam.mpid && queryParam.mpid.trim() !== '') {
      // allow only char and , in mpid
        if (!/^[0-9a-zA-Z,]+$/.test(queryParam.mpid)) {
          errorMessages.push('Invalid MMID(s)');
        }
      }
    }
    this.setState({ errorMessages: errorMessages });
    if (errorMessages.length === 0) {
      this.getSummaryDataFilter(queryParam);
    }
  }

  getSummaryDataFilter (queryParam) {
    var params = [];

    Object.keys(queryParam).forEach((key) => {
      let val = queryParam[key];
      if (val !== null) {
        if ((key === 'date' || key === 'startDate' || key === 'endDate') && moment.isDate(val)) {
          params[key] = moment(val).format(datePattern);
        } else if (typeof val === 'string') {
          if (val.trim() !== '') {
            params[key] = val;
          }
        } else {
          params[key] = val;
        }
      }
    });
    if (queryParam.summaryType === 'daily' || queryParam.summaryType === 'venueRange') {
      params.date = params.startDate;
    }

    //  console.log(params);
    this.props.search(params);
  }

  clearData () {
    this.setState(this.baseState);
    this.props.clear();
  }

  renderErrorMessages () {
    const errorMessages = this.state.errorMessages;
    return errorMessages.map((errorMessage, i) => <div key={`Error-${i}`}>{errorMessage}</div>);
  }

  handleKeyDown (e) {
    if (e.key === 'Enter') {
      this.setState({
        isSymbolFocus: false,
        isMpidFocus: false
      });

      this.handleSubmit();
    };
  }

  toggleMpidInfoTooltip () {
    this.setState({
      mpidInfoTooltip: !this.state.mpidInfoTooltip
    });
  }

  render () {
    const isDateRangerFilter = this.state && (this.state.summaryType === 'daily' || this.state.summaryType === 'venueRange');
    return (
      <div id='summaryFilter'>
        <div className={styles.filterGridStyle} onKeyDown={this.handleKeyDown}>
          <div key={'summaryTypesKey'}><label>{'Summary Type'}</label>
            <SelectBox id={'summaryType'}
              dataSource={summaryTypes}
              displayExpr='value'
              valueExpr='id'
              placeholder={'Summary Type'}
              value={this.state['summaryType']}
              name={'summaryType'}
              onValueChanged={(e) => this.handleChange(e, 'summaryType')} /></div>

          { !isDateRangerFilter && <div key={'dateKey'}><label>{'Trade Date'}</label><DateBox
            name={'date'}
            value={this.state['date']}
            placeholder={'MM/DD/YYYY'}
            useMaskBehavior
            openOnFieldClick
            max={new Date()}
            onValueChanged={(e) => this.handleChange(e, 'date')}
            displayFormat={filterDatePattern} /></div>
          }

          { isDateRangerFilter && <div key={'startDateKey'}><label>{'Trade Start Date'}</label><DateBox
            name={'startDate'}
            value={this.state['startDate']}
            placeholder={'MM/DD/YYYY'}
            useMaskBehavior
            openOnFieldClick
            max={new Date()}
            onValueChanged={(e) => this.handleChange(e, 'startDate')}
            displayFormat={filterDatePattern} /></div> }

          { isDateRangerFilter && <div key={'endDateKey'}><label>{'Trade End Date'}</label><DateBox
            name={'endDate'}
            value={this.state['endDate']}
            placeholder={'MM/DD/YYYY'}
            useMaskBehavior
            openOnFieldClick
            max={new Date()}
            onValueChanged={(e) => this.handleChange(e, 'endDate')}
            displayFormat={filterDatePattern} /></div> }

          <div key={'mpidKey'}><label><span>MPID</span>
            <span className={styles.mpidInfoIcon}>
              <i id={'mpidInfoIcon'} className={classNames('dx-icon-info')}
                onMouseEnter={this.toggleMpidInfoTooltip}
                onMouseLeave={this.toggleMpidInfoTooltip}
              />
            </span>
            <Tooltip
              target={'#mpidInfoIcon'}
              position='right'
              visible={this.state.mpidInfoTooltip}
              hideOnOutsideClick={false}
            > Specify Multiple MPID separated by comma</Tooltip>
          </label><TextBox
            name={'mpid'} placeholder={'MPID'} value={this.state['mpid']} showClearButton
            valueChangeEvent='keyup' disabled={this.state.summaryType !== 'sku'}
            onValueChanged={(e) => this.handleChange(e, 'mpid')} />

          </div>

        </div>

        <div className={styles.formControls}>
          <div>
            <Button title='Search' onClick={this.handleSubmit} size='extraSmall' />
            <TextLink className={styles.resetLink} size='small'
              text='Reset' onClick={this.clearData}
            />
          </div>
        </div>
        <div className={styles.errorMessages}>
          {this.state.errorMessages.length > 0 && this.renderErrorMessages()}
        </div>
      </div>
    );
  }
}
export default withRouter(SummaryFilter);

SummaryFilter.propTypes = {
  clear: PropTypes.func,
  search: PropTypes.func,
  location: PropTypes.object
};
